module.exports = __webpack_public_path__ + "media/stylesheets/images/active_admin/sample_200-e2128dcd866fe56a24f1fd677287aec0.png";